export const aufzugoNewConstruction = {
  bannerTextBig:
    'In wenigen Schritten passende Vergleichs&shy;angebote für den Aufzugsneubau erhalten',
  bannerTextBigSmallScreens: 'Vergleichs&shy;angebote für die Aufzugs&shy;neubau erhalten',
  bannerTextSmall: 'Erhalten Sie kostenlos bis zu drei Offerten von geprüften Qualitätsbetrieben',
  requestNewConstruction: 'NEUBAU ANFRAGEN',
  section1Title: 'Ein neuer Aufzug – so individuell wie Sie',
  section1Text:
    'Ein Aufzug ist Vertrauenssache. Mit unseren qualifizierten Fachpartnern erhalten Sie die professionelle Beratung, damit Sie künftig einen zuverlässigen Aufzug, welcher perfekt Ihren Bedürfnissen angepasst ist, Ihr Eigen nennen können.',
  advantageTitle: 'Finden Sie den optimalen Anbieter für Ihren neuen Aufzug',
}
